<div #ExtractFinancialComponent class="extract-financial-component">
  <div class="row header" #header>
    <div class="col-10">
      <mat-icon class="icon-order" svgIcon="file"></mat-icon>
      <span class="title">{{ title }}</span>
    </div>
    <div class="col-2 txt-right">
      <mat-icon class="icon-close-btn pointer" (click)="close()" svgIcon="close-btn"></mat-icon>
    </div>
  </div>
  <div class="filter">
    <div class="row network-error-message-oms" *ngIf="!statusOmsOnline">{{ msgStatusOmsOffile }}</div>
    <div class="row row-filter">
      <div class="col-10 col-datepicker">
        <span class="label">selecione o período desejado</span>
        <ngbd-datepicker-range [maxDateToday]='true' id="datepicker" class="modal-datepicker" [reset]="changingValue"
          [startEmpty]='false' [minOneYear]="true" (dateIni)="changeDateIni($event)" (dateFin)="changeDateFim($event)">
        </ngbd-datepicker-range>
      </div>
      <div class="col-2 col-btn-filter">
        <button mat-raised-button class="xs white" (click)="searchFilter()"
          [disabled]="!dateStartFilter || !dateEndFilter || !market">Buscar</button>
      </div>
    </div>
  </div>
  <div *ngIf="loading" class="spinner-get">
    <app-spinner-loading></app-spinner-loading>
  </div>
  <div class="extract" *ngIf="!loading">
    <table class="table" id="table-orders">
      <thead>
        <td class="text-header" style="width: 10%">Dt. Mov.</td>
        <td class="text-header" style="width: 10%">Dt. Liq.</td>
        <td class="text-header" style="width: 50%">Descrição</td>
        <td class="text-header" style="width: 10%">Débito</td>
        <td class="text-header" style="width: 10%">Crédito</td>
        <td class="text-header" style="width: 10%">Saldo</td>
      </thead>
      <tbody *ngIf="listExtract.length > 0">
        <tr *ngFor="let element of listExtract">
          <td class="center">{{ element.dtTransaction | date: 'dd/MM/yyyy' }}</td>
          <td class="center">{{ element.dtLiquidation }}</td>
          <td class="">{{ element.description}}</td>
          <td class="center">{{ !element.isDebPositive ? element.amount : '' }}</td>
          <td class="center">{{ element.isDebPositive ? element.amount : '' }}</td>
          <td class="center"
            [ngClass]="{'low-color' : element.isAmountPositive === 1, 'high-color' : element.isAmountPositive  === 2}">
            {{element.balance}}</td>
        </tr>
      </tbody>
      <div class="empty" *ngIf="listExtract.length === 0 && wasFetched">
        <app-empty-result [message]="msgNoExtractsFound"></app-empty-result>
      </div>
    </table>
  </div>
</div>
